<template>
  <div style="display: contents;">
    <ValidationObserver ref="bookingForm" slim>
      <b-form name="BookingPaxFrm" novalidate @submit.prevent="book()">
        <b-row>
          <b-container class="content">
            <div class="printArea">
              <b-row class="px-2 pb-2">
                <b-col>
                  <img :src="userData.logo" v-if="userData.logo" style="max-height: 50px;" />
                  <img src="@/assets/images/logos/logo.png" v-else height="50px">
                </b-col>
              </b-row>
              <SearchParamsSummary :params="params" />
              <HotelInfo :result="result" />
              <PackageInfo :pack="pack" :currency="params.currency" :showPrices="false" :showNotes="false" :showExtras="false" />
            </div>
            <!-- stacked table -->
            <b-row>
              <b-col sm="12" class="printArea">
                <b-table-simple stacked="sm" striped caption-top  class="table table-sm text-center">
                  <caption class="pl-2 pl-sm-0 pb-0"><h6 class="package-title" v-translate>Passengers and room details</h6></caption>
                  <b-thead class="t-head thead-light text-center">
                    <b-tr>
                      <b-td v-translate>Room</b-td>
                      <b-td></b-td>
                      <b-td v-translate>Last name*</b-td>
                      <b-td v-translate>First name*</b-td>
                      <b-td v-translate>Age</b-td>
                      <b-td v-translate>Date of birth*</b-td>
                    </b-tr>
                  </b-thead>
                  <b-tbody v-for="(room,rIndex) in pax" :key="rIndex">
                    <template v-for="(p, pIndex) in room">
                      <PaxForm
                        class="noPrint"
                        v-model="room[pIndex]"
                        :travelDate="travelDate"
                        :room="rIndex + 1"
                        :id="'room' + rIndex + 'pax' + pIndex"
                        :key="'pax' + pIndex"
                      />
                      <div :key="pIndex" style="display: none">
                        <tr>
                          <td>{{ rIndex + 1 }}</td>
                          <td>{{ room[pIndex].title }}</td>
                          <td>{{ room[pIndex].lname }}</td>
                          <td>{{ room[pIndex].fname }}</td>
                          <td>{{ room[pIndex].age }}</td>
                          <td>{{ room[pIndex].bdate }}</td>
                        </tr>
                      </div>
                    </template>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <!-- /stacked table -->
            <InvoicingForm v-model="client" v-if="userData.is_mandated === 't'"/>
            <b-row>
              <b-col md="12">
                <p style="color: rgb(112, 99, 90); font-size: 13px; margin-bottom:0;"><em>* <translate>Fields marked with asterisks are required.</translate></em></p>
                <hr />
              </b-col>
            </b-row>
            <b-row>
              <Extras
                :extras="category.extras"
                :currency="params.currency"
                :selectable="true"
                :travelDate="travelDate"
                @toggle="onExtraToggle"
                class="printArea"/>
            </b-row>
            <b-row class="my-3">
              <b-col>
                <div class="printArea">
                  <h6 v-translate>Agent notes*</h6>
                  <textarea v-model="notes" class="form-control noPrint">...</textarea>
                  <div class="printArea d-none"><p>{{notes}}</p></div>
                </div>
                <span>* <translate>In this field you can pass all the remarks / additional information related to the reservation (special requests of tourists or codes related to the offers where applicable).</translate></span>
                <!-- <span class="text-danger">
                  <translate>* ATTENTION! If you have checked the option of INTERNAL TRANSFER to additional or optional elements, please MANDATORY pass in this field the point of departure / return.</translate>
                </span><br />
                <translate>* ATTENTION! Special requests will be forwarded to service providers, but they cannot be guaranteed!</translate><br />
                <translate>* If this account is used by several colleagues within your agency - please enter your Name, Phone and Email here. This way we can communicate much easier and faster, directly with you related to this reservation!</translate></span> -->
              </b-col>
            </b-row>
            <b-row class="my-3 printArea">
              <b-col>
                <b-card no-header>
                  <b-row>
                    <b-col>
                      <b v-translate>Selected room category:</b> {{ category.name }}
                    </b-col>
                    <b-col>
                      <b v-translate>Selected meal plan:</b> {{ meal.label }}
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="7">
                <b-card>
                  <ValidationProvider
                    name="terms"
                    rules="is:acceptat"
                    vid="terms"
                    v-slot="vContext"
                    slim
                  >
                    <b-form-group>
                      <b-form-checkbox
                        id="conditions"
                        name="conditions"
                        v-model="termsAccepted"
                        :state="getValidationState(vContext)"
                        aria-describedby="conditions-live-feedback"
                        value="acceptat"
                        unchecked-value="neacceptat"
                        >
                          <translate>I have read and agree to the</translate> <span class="text-info"  @click="openTermsAndConditions" v-translate>Terms and Conditions</span> <translate>of the marketing products.</translate>
                        </b-form-checkbox>
                      <b-form-invalid-feedback id="conditions-live-feedback" :state="getValidationState(vContext)"><translate>you have not accepted the terms and conditions</translate></b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-card>
              </b-col>
              <b-col md="5" class="printArea">
                <b-card
                  bg-variant="light"
                  style="font-size:16px;"
                  class="text-center"
                >
                  <b-form-group>
                    <span><translate>PRICE:</translate> <span class="text-danger font-weight-bold">{{ price }} {{ params.currency }} </span> <small><translate>(tax included)</translate></small></span>
                    <br />
                    <small v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
                      {{ formatDate(dd.date) }} - <b>{{ ceil(dd.amount) || $gettext('balance') }}</b>
                    </small>
                  </b-form-group>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col>
                <b-card
                  bg-variant="light"
                  no-body
                >
                  <b-card-body class="p-1 p-md-3">
                    <div class="d-md-flex justify-content-md-between">
                      <b-button variant="warning" size="sm" @click="back" class="mb-2 mb-md-0"><b-icon icon="chevron-left" /><translate>Back to results</translate></b-button>
                      <b-button-group size="sm">
                        <button class="btn btn-outline-primary btn-sm " @click.prevent="onPrint" v-b-tooltip.hover :title="$gettext('Print')">
                          <b-icon icon="file-earmark-text" /> <translate>Print details</translate>
                        </button>
                        <button class="btn btn-outline-danger btn-sm" @click.prevent="onDownload" v-b-tooltip.hover :title="$gettext('PDF')">
                          <b-icon icon="download" /> <translate>Pdf details</translate>
                        </button>
                        <b-button
                          v-if="category.allowOption"
                          @click.prevent="book(true)"
                          variant="primary custom-primary"
                          v-b-popover.hover.top="$gettext('ATTENTION: Booking in OPTION is not guaranteed: seats are blocked on the plane, but the availability of the hotel is not guaranteed, which can enter Stop Sales')"
                          :title="$gettext('Attention!')" v-translate>Option</b-button>
                        <b-button variant="warning" type="submit"  @click.prevent="book(false)" v-translate>Book</b-button>
                      </b-button-group>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-form>
    </ValidationObserver>
    <b-modal v-model="showOverlay" :title="$gettext('Status')" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <b-aspect class="align-items-center text-center" aspect="3">
          <b-spinner :label="$gettext('Loading...')" variant="primary"></b-spinner>
          <b-card-text>{{ overlayMessage }}</b-card-text>
        </b-aspect>
      </b-card>
    </b-modal>
    <b-modal v-model="showErrorOverlay" :title="$gettext('Error')" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card class="justify-content-center">
        <b-aspect aspect="3" class="align-items-center">
          <b-card-title class=" font-weight-bold text-center">
            <b-icon icon="exclamation-triangle" class="text-danger mr-3"/>
            <translate> There was a problem</translate>
          </b-card-title>
          <hr>
          <b-card-text class="lead text-muted" v-translate> - Unfortunately the reservation could not be registered because a problem occurred.</b-card-text>
          <b-card-text class="lead text-muted" v-translate> - Generally, this happens when the price or availability of the product has changed since you searched.</b-card-text>
          <b-card-text class="lead text-muted" v-translate> The error message is: <b class="text-info">{{ errorMessage }}</b></b-card-text>
        </b-aspect>
        <hr>
        <b-button variant="warning float-right" size="sm" @click="back" v-translate>Back to results</b-button>
      </b-card>
    </b-modal>
    <b-modal v-model="termsAndConditions" :title="$gettext('Terms and Conditions')" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <TermsAndConditions />
        <hr>
        <b-button variant="warning" class="float-right"  @click="closeTermsAndConditions" v-translate>Save</b-button>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

import model from '../services/model'
import toast from 'b2b-common/mixins/toast'
import auth from 'b2b-common/mixins/auth'
import validation from 'b2b-common/mixins/validation'
import SearchParamsSummary from './search_params_summary'
import PackageInfo from './package_info'
import Extras from './extras'
import HotelInfo from '@/app/private/shared/components/hotel_info'
import PaxForm from '@/app/private/shared/components/pax_form'
import InvoicingForm from '@/app/private/shared/components/invoicing_info_form'
import TermsAndConditions from '../../shared/components/terms_and_conditions'
import { $gettext } from '@/config/gettext'

import { getCustomPdf, downloadPdf, openPrintPage } from 'b2b-common/services/api/document'
import { search, book, paymentSchedule } from 'b2b-common/services/api/package'

const calculatePrice = (category, meal, selectedExtras) => {
  let p = meal.price + meal.tax
  category.extras.forEach(extra => {
    if (!extra.optional) p += extra.price
  })
  selectedExtras.forEach(index => {
    if (!category.extras[index]) throw new Error('Extra not found')
    const extra = category.extras[index]
    if (extra.optional) p += extra.price
  })
  return p
}

const invalidFormMessage = $gettext('Invalid Form')

export default {
  mixins: [toast, auth, validation],
  props: ['params', 'result', 'pack', 'category', 'meal'],
  components: { PackageInfo, HotelInfo, SearchParamsSummary, InvoicingForm, Extras, PaxForm, TermsAndConditions },
  computed: {
    price () {
      return calculatePrice(this.category, this.meal, this.selectedExtras)
    }
  },
  data () {
    const travelDate = moment.unix(this.params.date)

    const rooms = []
    let noAdults = 0
    let noChildren = 0
    this.params.rooms.forEach(room => {
      const pax = []
      noAdults += room.adults
      noChildren += room.ages.length
      for (let i = 0; i < room.adults; i++) {
        pax.push({
          title: 'Mr',
          fname: '',
          lname: '',
          age: 'adult',
          bdate: null
        })
      }
      room.ages.forEach(age => {
        pax.push({
          title: (age < 2) ? 'Inf' : 'Chd',
          fname: '',
          lname: '',
          age: age,
          bdate: null
        })
      })
      rooms.push(pax)
    })

    return {
      travelDate,
      noAdults,
      noChildren,
      notes: '',
      pax: rooms,
      selectedExtras: [],
      termsAccepted: 'unaccepted',
      client: {
        clientCode: '',
        isCompany: false,
        companyName: '',
        companyNo: '',
        vatNo: '',
        bankAccount: '',
        bankName: '',
        title: 'Mr',
        firstName: '',
        lastName: '',
        idInfo: '',
        cnp: '',
        address1: '',
        address2: '',
        county: '',
        city: '',
        tel: '',
        email: ''
      },
      showErrorOverlay: false,
      showOverlay: false,
      overlayMessage: '',
      errorMessage: this.$gettext('unknown error'),
      termsAndConditions: false,
      paymentSchedule: []
    }
  },
  async created () {
    this.paymentSchedule = await paymentSchedule({
      packageType: model.params.packageType,
      result: this.result.index,
      pack: this.pack.index,
      category: this.category.id,
      meal: this.meal.id
    })
  },
  methods: {
    onPrint () {
      this.$refs.bookingForm.validate()
        .then(success => {
          if (!success) {
            this.addToast({ title: invalidFormMessage, message: this.$gettext('Please fill in all required fields!'), variant: 'danger' })
            return
          }
          const arr = document.getElementsByClassName('printArea')
          let html = ''
          arr.forEach(el => {
            html += el.innerHTML
          })
          openPrintPage({ html })
        })
    },
    onDownload () {
      this.$refs.bookingForm.validate()
        .then(success => {
          if (!success) {
            this.addToast({ title: invalidFormMessage, message: this.$gettext('Please fill in all required fields!'), variant: 'danger' })
            return
          }
          const arr = document.getElementsByClassName('printArea')
          let html = ''
          arr.forEach(el => {
            html += el.innerHTML
          })
          getCustomPdf({ html })
            .then(pdfData => {
              downloadPdf({ pdfData, fileName: this.$pgettext('file name do not use special characters, please use ASCII only', 'offer') + '.pdf', dataType: 'raw' })
            })
        })
    },
    back () {
      this.$emit('back')
    },
    openTermsAndConditions () {
      this.termsAndConditions = true
    },
    closeTermsAndConditions () {
      this.termsAndConditions = false
    },
    async book (isOption = false) {
      try {
        const success = await this.$refs.bookingForm.validate()
        if (!success) {
          this.addToast({ title: invalidFormMessage, message: this.$gettext('Please fill in all required fields!'), variant: 'danger' })
          return Promise.reject(new Error(invalidFormMessage))
        }
        this.showOverlay = true
        this.overlayMessage = this.$gettext('Please wait, we check again the price and availability of the selected product ...')

        // run new search
        const newParams = model.params
        newParams.hotels = [this.result.id]
        model.params = newParams
        const data = await search(newParams)

        // check that availability has not changed
        let avaHasChanged = false
        if (data.has_transport !== model.hasTransport) avaHasChanged = true

        // re-populate model
        model.results = data.results
        model.hasTransport = data.has_transport
        model.sort({ sortMethod: model.sortMethod })

        if (avaHasChanged) throw new Error(this.$gettext('Difference in transport availability found'))

        // check that we can find the same result
        const newResIndex = data.results.findIndex(el => el.id === this.result.id)
        if (newResIndex < 0) throw new Error(this.$gettext('Could not find hotel'))
        const newResult = data.results[newResIndex]
        const newPackIndex = newResult.packages.findIndex(el => el.id === this.pack.id)
        if (newPackIndex < 0) throw new Error(this.$gettext('Could not find package'))
        const newPack = newResult.packages[newPackIndex]
        // check that we have the same category
        const newCategoryIndex = newPack.categories.findIndex(el => (el.name === this.category.name))
        if (newCategoryIndex < 0) throw new Error(this.$gettext('Could not find category'))
        const newCategory = newPack.categories[newCategoryIndex]

        // check that hotel availability has not changed
        if ((newCategory.transportIsAvailabe !== this.category.transportIsAvailabe) ||
            (newCategory.hotelIsAvailable !== this.category.hotelIsAvailable) ||
            (newCategory.hotelIsBlackedOut !== this.category.hotelIsBlackedOut) ||
            (newCategory.isBookable !== this.category.isBookable)) {
          throw new Error(this.$gettext('Difference in availability found'))
        }

        const newMealIndex = newCategory.meals.findIndex(el => (el.code === this.meal.code) && (el.label === this.meal.label))
        if (newMealIndex < 0) throw new Error(this.$gettext('Could not find meal'))
        const newMeal = newCategory.meals[newMealIndex]
        // checkPrice
        const p1 = calculatePrice(newCategory, newMeal, this.selectedExtras)
        const p2 = calculatePrice(this.category, this.meal, this.selectedExtras)
        if (p1 !== p2) throw new Error(this.$gettext('Price difference found'))

        const pax = [...this.pax.map(room => room.map(p => ({
          title: p.title,
          fname: p.fname.toUpperCase(),
          lname: p.lname.toUpperCase(),
          age: p.age,
          bdate: p.bdate
        })))]
        // now ok to create booking
        const bookParams = {
          packageType: model.params.packageType,
          category: newCategory.id,
          meal: newMeal.id,
          notes: this.notes,
          extras: this.selectedExtras,
          pax: pax
        }
        if (isOption) bookParams.status = 'option'
        const res = await book(bookParams)

        model.results = []
        this.$emit('book', res[0])
      } catch (err) {
        if (err.message !== invalidFormMessage) {
          this.errorMessage = err.message
          this.showErrorOverlay = true
        }
      } finally { this.showOverlay = false }
    },
    onExtraToggle (extraIndex) {
      const index = this.selectedExtras.indexOf(extraIndex)
      if (index >= 0) this.selectedExtras.splice(index, 1)
      else this.selectedExtras.push(extraIndex)
    },
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    ceil (no) {
      if (no === null || no === undefined) return null
      return Math.ceil(no) + this.params.currency
    }
  }
}
</script>
